<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>服务者系统操作日志</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card shadow="hover">
      <el-form :inline="true" size="small" v-model="query">
        <el-form-item label="开始时间">
          <el-date-picker v-model="query.startTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                          style="width: 100%"></el-date-picker>

        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="query.endTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                          style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="操作人">
          <el-input v-model="query.operName" placeholder="请输入操作人"></el-input>
        </el-form-item>
        <el-button class="filter-item" type="primary" icon="el-icon-search" @click="queryList()">查询</el-button>

      </el-form>
    </el-card>
    <el-table :data="list" border highlight-current-row>
      <el-table-column prop="systemName" label="请求系统" width="130px"></el-table-column>
      <el-table-column prop="userId" label="用户id" width="80px"></el-table-column>
      <el-table-column prop="userName" label="用户名" width="100px"></el-table-column>
      <el-table-column prop="functionName" label="请求方法"></el-table-column>
      <el-table-column prop="requestIp" label="来源ip"></el-table-column>
      <el-table-column prop="requestUrl" label="请求url" width="300px"></el-table-column>
      <el-table-column prop="requestParm" label="请求参数"></el-table-column>
      <el-table-column prop="createTime" label="请求时间">
        <!-- 格式化时间        -->
        <template slot-scope="scope">
          <span>{{
              format(scope.row.createTime)
            }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :page.sync="pageNum" :limit.sync="pageSize"
                @pagination="queryList(pageNum,pageSize)"/>
  </div>
</template>

<script>
import service from "@/script/api/service";
import moment from "moment";
import Pagination from "@/components/common/Pagination";

export default {
  components: {Pagination},
  data() {
    return {
      query: {
        startTime: '',
        endTime: '',
        operator: ''

      },
      total: 0,
      pageNum: 1,
      pageSize: 50,
      list: []
    }
  },
  methods: {
    queryList(pageNum, pageSize) {
      let params = {
        pageNo: pageNum ? pageNum : 1,
        pageSize: pageSize ? pageSize : 50,
        ...this.query
      };
      service.$axioSysLogGetPageList(params).then(res => {
        console.log(JSON.stringify(res));
        this.total = res.data.data.total;
        this.list = res.data.data.list;
      })

    },
    format(row) {
      return moment(row.createTime).format('YYYY-MM-DD HH:mm:ss');
    }
  }
}
</script>

<style scoped>

</style>
